import { render, staticRenderFns } from "./AdminInBodyTable.vue?vue&type=template&id=e286b71e&scoped=true"
import script from "./AdminInBodyTable.vue?vue&type=script&lang=js"
export * from "./AdminInBodyTable.vue?vue&type=script&lang=js"
import style0 from "./AdminInBodyTable.vue?vue&type=style&index=0&id=e286b71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e286b71e",
  null
  
)

export default component.exports